export const EXPERT_SYSTEM_KPI_REQUEST_STALE_TIME = 1000 * 60 * 15 // 15 minutes
